import { useCustomer } from 'hooks/context/customer/customer';
import { useDelivery } from 'hooks/context/Delivery';
import { useServiceType } from 'hooks/context/serviceType';
import { useOrderDetails } from 'routes/Checkout/context/OrderDetails';
import { toCents } from 'util/Formatting';
import { useColoRequest } from './useColoRequest';
import { useGiftCard } from 'routes/Checkout/context/GiftCard/GiftCardContext';

export function usePutApplePayOrderPayment(merchantUuid?: string) {
  const {
    contactFormData: { customer },
    tipValue,
  } = useOrderDetails();
  const { deliveryAddress: address } = useDelivery();
  const {
    isDelivery,
    typeMetadata: { isContactlessDelivery, note },
  } = useServiceType();
  const { sessionToken } = useCustomer();
  const { appliedGiftCards } = useGiftCard();

  const [, putApplePayOrderPayment] = useColoRequest(
    (paymentToken, orderUuid) => {
      const { email, ...customerInfo } = customer;

      return (
        merchantUuid && {
          method: 'PUT',
          url: `${merchantUuid}/orders/${orderUuid}/payments`,
          headers: {
            'X-Clover-Customer-Auth': sessionToken,
          },
          data: {
            paymentToken,
            email,
            tipAmount: toCents(tipValue),
            ...(!!appliedGiftCards?.length && { giftSources: appliedGiftCards }),
            deliveryInfo: isDelivery ? {
              address,
              customer: customerInfo,
              note,
              isContactlessDelivery,
            } : undefined,
          },
        }
      );
    },
    [merchantUuid, sessionToken, customer, tipValue, address, note, isContactlessDelivery,appliedGiftCards]
  );

  return {
    putApplePayOrderPayment,
  };
}
